const useCases = [
  {
    title: 'Surf Trips',
    subtitle: 'Carry-on friendly kits',
    description: 'Pack a micro kit in your carry-on and never let airline damage ruin a surf trip again. Repair on the beach minutes after landing.',
    image: 'https://public.readdy.ai/ai/img_res/dc375e7596886330d72ec06666b83518.jpg',
    tag: 'Travel',
  },
  {
    title: 'Beachside Repairs',
    subtitle: 'Between sessions',
    description: 'Ding between sets? Grab your kit from the bag, apply, cure in the sun for 2 minutes, and paddle back out. No session lost.',
    image: 'https://readdy.ai/api/search-image?query=surfer%20kneeling%20on%20beach%20repairing%20surfboard%20ding%20between%20surf%20sessions%20beach%20kit%20tools%20laid%20out%20tropical%20beach%20sunny%20lifestyle&width=700&height=500&seq=uc2&orientation=landscape',
    tag: 'Beach',
  },
  {
    title: 'Airline Damage Fixes',
    subtitle: 'Fix it before you surf',
    description: 'Boards damaged in transit are a reality. PHIX Doctor gets you from airport to water fast — repair at the hotel, cure in the sun, done.',
    image: 'https://readdy.ai/api/search-image?query=surfer%20inspecting%20airline%20damaged%20surfboard%20hotel%20balcony%20tropical%20destination%20repair%20kit%20in%20hand%20sun%20shining%20outdoor%20lifestyle&width=700&height=500&seq=uc3&orientation=landscape',
    tag: 'Emergency',
  },
  {
    title: 'DIY Home Repairs',
    subtitle: 'Your board, your workshop',
    description: 'Fix dings, rail damage, and pressure dents at home without the cost of a ding shop. Professional results without professional prices.',
    image: 'https://readdy.ai/api/search-image?query=surfer%20doing%20DIY%20surfboard%20repair%20at%20home%20garage%20workshop%20repair%20tools%20laid%20out%20surfboard%20on%20sawhorses%20bright%20natural%20lighting&width=700&height=500&seq=uc4&orientation=landscape',
    tag: 'DIY',
  },
];

export default function UseCases() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-[#FF6B35] text-sm font-bold uppercase tracking-widest mb-3">Real Scenarios</p>
          <h2 className="text-4xl md:text-5xl font-black text-stone-900">
            Repair Anywhere,<br />
            <span className="text-[#0B5C4D]">Anytime</span>
          </h2>
        </div>

        <div className="space-y-0">
          {useCases.map((useCase, idx) => (
            <div
              key={useCase.title}
              className={`flex flex-col ${idx % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center gap-0 border-b border-stone-100 last:border-0`}
            >
              {/* Image */}
              <div className="w-full lg:w-[55%] h-72 lg:h-96 overflow-hidden">
                <img
                  src={useCase.image}
                  alt={useCase.title}
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-500"
                />
              </div>
              {/* Text */}
              <div className="w-full lg:w-[45%] p-10 lg:p-16">
                <span className="inline-block bg-[#FF6B35]/10 text-[#FF6B35] text-xs font-bold uppercase tracking-widest px-3 py-1 rounded-full mb-4">
                  {useCase.tag}
                </span>
                <h3 className="text-stone-900 font-black text-3xl mb-2">{useCase.title}</h3>
                <p className="text-[#0B5C4D] font-semibold text-base mb-4">{useCase.subtitle}</p>
                <p className="text-stone-500 text-base leading-relaxed mb-6">{useCase.description}</p>
                <a href="#" className="inline-flex items-center gap-2 text-[#0B5C4D] font-bold text-sm hover:gap-3 transition-all cursor-pointer">
                  Learn More
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line" />
                  </div>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
